"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.slice.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.object.to-string.js");
var _mixins = _interopRequireDefault(require("./mixins"));
var _JmPrint = _interopRequireDefault(require("@/components/common/JmPrint"));
var _IcePrint = _interopRequireDefault(require("@/components/common/IcePrint"));
var _request = _interopRequireDefault(require("@utils/request"));
var _cloud = require("@utils/cloud");
// import WlTableMain from '@/components/wl-table-main/wl-table-main.vue'
// import WlTree from './components/wl-tree.vue'
var _default = exports.default = {
  name: 'wl-list',
  mixins: _mixins.default,
  components: {
    IcePrint: _IcePrint.default,
    JmPrint: _JmPrint.default
  },
  // components: { WlTableMain, WlDrawerSearch/* , WlTree */ },
  data: function data() {
    return {
      /* 等待状态 */
      loading: {
        table: false,
        tree: false
      },
      treeData: [],
      tableDatas: [],
      tableOperations: [],
      queryValue: '',
      optionInit: {
        table: {
          // 动态数据源
          dataSource: null,
          staticTable: false,
          // 选择模式
          chooseMode: 'multiple',
          // 是否启用填充列
          needFill: false
          // border     : true
        }
      }
    };
  },
  /* 父组件可调用方法 Methods */
  methods: {
    /**
     * @description: 设置选中行
     * @param { * } selections - 分页器属性
     * @return { Boolean } 设置成功状态
     */
    setSelections: function setSelections() {
      var _this$$refs$wlTable;
      return (_this$$refs$wlTable = this.$refs['wl-table-main']) === null || _this$$refs$wlTable === void 0 ? void 0 : _this$$refs$wlTable.setSelections.apply(_this$$refs$wlTable, arguments);
    },
    /**
     * @description: 获取 单个 ref 绑定数据
     * @param { !String  } target 要获取的目标
     * @return { Object } 返回ref绑定的单个VUE实例对象
     */
    getRef: function getRef(target) {
      var _this$$refs$wlTable2, _this$$refs$wlTable3, _this$$refs$wlTree;
      switch (target) {
        case 'table-main':
          return this.$refs['wl-table-main'];
        case 'table':
          return (_this$$refs$wlTable2 = this.$refs['wl-table-main']) === null || _this$$refs$wlTable2 === void 0 ? void 0 : _this$$refs$wlTable2.$refs['el-table'];
        case 'pagination':
          return (_this$$refs$wlTable3 = this.$refs['wl-table-main']) === null || _this$$refs$wlTable3 === void 0 ? void 0 : _this$$refs$wlTable3.$refs['el-pagination'];
        case 'search':
          return this.$refs['wl-drawer-search'];
        case 'tree-main':
          return this.$refs['wl-tree'];
        case 'tree':
          return (_this$$refs$wlTree = this.$refs['wl-tree']) === null || _this$$refs$wlTree === void 0 ? void 0 : _this$$refs$wlTree.$refs['el-tree'];
        default:
          return null;
      }
    },
    /**
     * @description: 获取 多个 ref 绑定数据
     * @param { !(String[] | String) } target 要获取的目标
     * @return { Object[] | Object } 返回ref绑定的多个VUE实例对象
     */
    getRefs: function getRefs(target) {
      if (typeof target === 'string') return this.getRef(target);else if (Array.isArray(target)) {
        var a = this.$$anyInArray(target);
        return a.map(this.getRef);
      }
      // eslint-disable-next-line no-console
      console.warning('警告：getRefs方法只接受 String | Array[String] 两种数据类型');
      return null;
    },
    /**
     * @description: 获取 表格选中条目
     * @param { Function } fun 按钮对象
     * @param { Array } fun.a 选中条目
     * @param { Array } fun.b 选中条目中被作为行key的字段
     * @param { Array } fun.c 选中条目中被作为行label的字段
     * @return { Array } 表格选中条目
     */
    getSelection: function getSelection(fun) {
      var a = [],
        b = [],
        c = [];
      this.$refs['wl-table-main'].getSelection(function () {
        var _arguments = Array.prototype.slice.call(arguments);
        a = _arguments[0];
        b = _arguments[1];
        c = _arguments[2];
      });
      typeof fun === 'function' && fun(a, b, c);
      this.$$listenersEmit('selection', a, b, c);
      return a;
    },
    /**
     * @description: 获取 分页数据
     * @return { Object } 分页数据对象
     */
    getPagination: function getPagination() {
      return this.$refs['wl-table-main'].getPagination();
    },
    /** 删除表格节点
     * @description: 删除节点
     * @param { Object } row 需要删除的行数据
     * @return { Object } 返回被删除行的行数据对象
     */
    tableDeleteData: function tableDeleteData(row) {
      return this.$refs['wl-table-main'].deleteRow(row);
    },
    /** 重置数据
     * @description: 重置数据
     * @return { void }
     */
    reset: function reset() {
      var _this$$refs$wlTree2;
      this.$refs['wl-table-main'].setPagination({
        pageSize: 10,
        currentPage: 1
      });
      (_this$$refs$wlTree2 = this.$refs['wl-tree']) === null || _this$$refs$wlTree2 === void 0 || _this$$refs$wlTree2.reset();
      var a = this.$$listenersEmit('node-click', {}, {}, {});
      var b = this.$$listenersEmit('tree-node-click', {}, {}, {});
      if (!a && !b) this.getDatas();
    },
    /** 刷新数据
     * @description: 刷新数据
     * @return { void }
     */
    refresh: function refresh() {
      this.getDatas();
    },
    /** 删除行
     * @description: 删除行
     * @param { Object } row 删除行
     * @return { void }
     */
    deleteRow: function deleteRow(row) {
      return this.$refs['wl-table-main'].deleteRow(row);
    }
  },
  created: function created() {
    this.init();
  },
  mounted: function mounted() {
    var _this$$refs$wlTree3;
    /* 如果左树图没有数据源，则请求表格 */
    var a = (_this$$refs$wlTree3 = this.$refs['wl-tree']) === null || _this$$refs$wlTree3 === void 0 ? void 0 : _this$$refs$wlTree3.getDatas;
    typeof a === 'function' && a();
    this.getDatas();
    // if (typeof a === 'function' && !a()) this.getDatas()
  }
};